
export class RecoveryFailureEvent {
	constructor(
		public helpMessages: string[],
	) {
	}
}
